import { TranslateLoader } from '@ngx-translate/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { finalize, map, switchMap, tap } from 'rxjs/operators';
import { Injector, inject } from '@angular/core';
import { BaseService } from './shared';

export class CustomLoader implements TranslateLoader {
    constructor(private http: HttpClient) { }
    baseService = inject(BaseService);
    getTranslation(langCountry: string): Observable<any> {
        const UserLangId = localStorage.getItem('userLanguage') || '4c7d3ec0-e0e8-467d-b1ab-777c5c153644';
       
       // const isTransatedObjCalled=localStorage.getItem('isTransatedObjCalled')
   //   if ( !isTransatedObjCalled ||  isTransatedObjCalled!='Yes')
      
        // return this.baseService.get(`Localization/GetCultTransObjectDirect/${UserLangId}`).pipe(
        //     switchMap((result) => {
        //         if (result.isSuccess) {
        //           //  localStorage.setItem('isTransatedObjCalled','Yes')
        //             return of(result.data);
        //         } else
        this.baseService.finishedLoadingTranslation.next(true);

                 return this.http.get('/assets/i18n/' + langCountry + '.json');
            // }),
            // finalize(() => {
            //     setTimeout(() => {
        //         }, 100);
        //     })
        // );
    }
}
